// Knop "Naar Operatie" bij een taak, plus de status van wat Operatie ermee gedaan heeft.
// Wordt gebruikt in Taken en in het klantdossier.
import { useCallback, useEffect, useState } from "react";
import { supabase } from "../supabase";
import { C, Chip } from "./gedeeld";
import { stuurTaakNaarOperatie, operatieStatusVoorTaken } from "./operatieTaak";

// Houdt per taak bij wat Operatie ermee deed, en ververst zodra de wachtrij verandert.
export function useOperatieStatus(taken) {
  const [map, setMap] = useState({});
  const sleutel = (taken || []).map((t) => t.id).join(",");
  const ververs = useCallback(async () => {
    const ids = sleutel ? sleutel.split(",") : [];
    setMap(await operatieStatusVoorTaken(ids));
  }, [sleutel]);
  useEffect(() => { ververs(); }, [ververs]);
  useEffect(() => {
    const ch = supabase.channel("operatie_taak_sync_" + Math.random().toString(36).slice(2, 8))
      .on("postgres_changes", { event: "*", schema: "public", table: "proposed_changes" }, () => ververs())
      .subscribe();
    return () => { supabase.removeChannel(ch); };
  }, [ververs]);
  return [map, ververs];
}

export default function OperatieKnop({ taak, status, user, setView, naVerzenden, compact }) {
  const [bezig, setBezig] = useState(false);
  const [fout, setFout] = useState("");
  const [klaar, setKlaar] = useState(null);

  if (!taak || taak.status === "done") {
    return status && status.status === "applied" ? <Chip tekst="door Operatie uitgevoerd" kleur={C.green} /> : null;
  }

  async function verstuur() {
    setBezig(true); setFout("");
    try {
      const r = await stuurTaakNaarOperatie(taak, user && user.email);
      setKlaar(r);
      if (naVerzenden) await naVerzenden();
    } catch (e) { setFout(e.message || "Mislukt"); }
    setBezig(false);
  }

  const knopStijl = compact ? { padding: "3px 8px", fontSize: 11 } : { fontSize: 11 };
  const draaitInAchtergrond = (status && status.status === "bezig") || (klaar && klaar.achtergrond);
  const mislukt = status && status.status === "mislukt";
  const wacht = (status && status.status === "pending") || (klaar && !klaar.achtergrond);
  const goedgekeurd = status && (status.status === "approved" || status.status === "failed");
  const afgewezen = status && status.status === "rejected";

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
      {(bezig || draaitInAchtergrond) && <Chip tekst={draaitInAchtergrond && !bezig ? "Operatie werkt eraan, je hoeft niet te wachten" : "Operatie werkt eraan..."} kleur={C.blue} />}
      {!bezig && !draaitInAchtergrond && wacht && (
        <span style={{ cursor: "pointer" }} onClick={() => setView && setView("goedkeuringen")} title="Open Goedkeuringen">
          <Chip tekst={klaar && klaar.menselijkeStappen ? "wacht op jouw akkoord (+" + klaar.menselijkeStappen + " eigen stappen)" : "wacht op jouw akkoord"} kleur={C.yellow} />
        </span>
      )}
      {!bezig && !draaitInAchtergrond && !wacht && goedgekeurd && <Chip tekst="goedgekeurd, nog toepassen" kleur={C.blue} />}
      {!bezig && !draaitInAchtergrond && !wacht && afgewezen && <Chip tekst="afgewezen" kleur={C.red} />}
      {!bezig && !draaitInAchtergrond && !wacht && !goedgekeurd && (
        <button className="btn bg" style={knopStijl} onClick={verstuur} title="Laat de Operatie-uitvoerder deze taak uitwerken. Jij keurt het resultaat goed.">{afgewezen || mislukt ? "Opnieuw naar Operatie" : "Naar Operatie"}</button>
      )}
      {!bezig && mislukt && <span style={{ fontSize: 11, color: C.red }} title={status.fout}>mislukt: {String(status.fout || "").slice(0, 60)}</span>}
      {fout && <span style={{ fontSize: 11, color: C.red }}>{fout}</span>}
    </span>
  );
}
